import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const AUTO_LIST_FIELD_OPTION_CLASS_NAME = 'AutoListFieldOption';
export const AUTO_LIST_FIELD_OPTION_CLASS_SLOTS = [
	'root',
	'avatar',
	'coloredAvatar',
	'icon',
	'listItemIcon',
] as const;

export type AutoListFieldOptionClassSlot =
	typeof AUTO_LIST_FIELD_OPTION_CLASS_SLOTS[number];

export interface AutoListFieldOptionClasses {
	root: string;
	avatar: string;
	coloredAvatar: string;
	icon: string;
	listItemIcon: string;
}

export type AutoListFieldOptionClassKey = keyof AutoListFieldOptionClasses;

export const getAutoListFieldOptionUtilityClass = (slot: string) =>
	generateUtilityClass(AUTO_LIST_FIELD_OPTION_CLASS_NAME, slot);

export const autoListFieldOptionClasses = generateUtilityClasses<
	keyof AutoListFieldOptionClasses
>(AUTO_LIST_FIELD_OPTION_CLASS_NAME, [
	'root',
	'avatar',
	'coloredAvatar',
	'icon',
	'listItemIcon',
]);

export default autoListFieldOptionClasses;
